module.exports = __webpack_public_path__ + "images/59ec6a43cd5723899d6d9e7f92635b2f-profile_overlay.jpg";